'use strict';

/**
 * Check if the value is a valid hex string.
 */ function isHex(value) {
    return /^(0x|0X)?[a-fA-F0-9]+$/.test(value) && value.length % 2 === 0;
}
/**
 * Get the byte length of a hex string.
 */ function getHexByteLength(value) {
    return /^(0x|0X)/.test(value) ? (value.length - 2) / 2 : value.length / 2;
}

exports.getHexByteLength = getHexByteLength;
exports.isHex = isHex;
//# sourceMappingURL=utils.js.map
